var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('tablepage',{ref:"tableref",attrs:{"id":"tableref","cols":_vm.cols,"items":_vm.items,"total":_vm.total,"perpage":_vm.Count},on:{"currentPage":_vm.currentPage,"currentRow":_vm.currentRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }